import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import { useContext } from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import { GameContext } from '../GameProvider'
import { useHistory } from 'react-router-dom'
import { makePath } from '../../../lib'
import { useState } from 'react'
import { FormControl, IconButton, Input, InputAdornment, InputLabel } from '@material-ui/core'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import { SettingsContext } from '../../../Parts/Settings'
import { useEffect } from 'react'
import { useRef } from 'react'
import { Word } from '../../../components'
import { WID } from '../../../constants/Language'

const styles = theme => ({
  root: {
  }
})

const RequestPasswordDialog = (props) => {
  const { classes } = props

  const gameContext = useContext(GameContext)
  const history = useHistory()
  const settingsContext = useContext(SettingsContext)
  const { language } = settingsContext

  const [visiblePassword, setVisiblePassword] = useState(false)
  const [password, setPassword] = useState('')

  var prevOpen = useRef(gameContext.requestPasswordDialog.open)

  const handleClose = () => {
    gameContext.closeRequestPasswordDialog()
    history.push(makePath('/game', language))
  }

  const handleEnter = () => {
    gameContext.joinRoom(gameContext.urlGroupName, gameContext.urlRoomName, password)
    gameContext.closeRequestPasswordDialog()
  }

  const handleChangePassword = (event) => {
    setPassword(event.target.value)
  }

  useEffect(() => {
    if (
      !prevOpen.current &&
      gameContext.requestPasswordDialog.open
    ) {
      setPassword('')
    }
    prevOpen.current = gameContext.requestPasswordDialog.open
  }, [gameContext.requestPasswordDialog.open])

  return (
    <Dialog className={classes.root} open={gameContext.requestPasswordDialog.open} onClose={handleClose}>
      <DialogContent>
        <FormControl>
          <InputLabel htmlFor="standard-adornment-password"><Word wid={WID.REQUEST_PASSWORD_DIALOG.LABEL}/></InputLabel>
          <Input
            id="standard-adornment-password"
            type={visiblePassword ? 'text' : 'password'}
            value={password}
            onChange={handleChangePassword}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setVisiblePassword(!visiblePassword)}
                >
                  {visiblePassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
        <Button onClick={handleEnter} variant='contained' color='primary'>Enter</Button>
      </DialogActions>
    </Dialog>
  )
}

export default withStyles(styles, { withTheme: true })(RequestPasswordDialog)



// WEBPACK FOOTER //
// ./src/Pages/Game/components/RequestPasswordDialog.js